import { FC } from "react";

interface ITitle extends React.ButtonHTMLAttributes<HTMLHeadingElement> {
  title: string;
}

const H2: FC<ITitle> = ({ title, ...props }: ITitle) => {
  return (
    <h2 {...props} className="font-h2 text-h2">
      {title}
    </h2>
  );
};
export default H2;
